import _ from 'lodash';
import { formatImageUrl } from '../../utils/format';

interface GetDefaultImagesProp {
  id: number;
  ordem: number;
}

interface GetDefaultImages {
  index: number;
  src: string;
  id: number;
  ordem: number;
}

export function getDefaultImages(
  imagemAnuncio: GetDefaultImagesProp[] | undefined
): GetDefaultImages[] | null {
  if (imagemAnuncio && imagemAnuncio.length) {
    const orderOfFirstImage = _.get(imagemAnuncio, ['0', 'order'], 0);
    return imagemAnuncio.map(({ ordem, id }) => ({
      index: ordem - orderOfFirstImage,
      src: formatImageUrl(id),
      id,
      ordem
    }));
  }
  return null;
}
